/*
  src/redux/notifications/actions.js

  Created by erikchristensen on 11/22/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import {
  NOTIFICATION_SHOWN,
  NOTIFICATION_DISMISSED
} from './constants';

import { generateGUID } from '../../../shared/utils';

export function showNotification(kind,message){
  return {
    type:NOTIFICATION_SHOWN,
    payload:{
      message:message,
      kind:kind,
      id:generateGUID()
    }
  }
}

export function dismissNotification(id){
  return {
    type:NOTIFICATION_DISMISSED,
    payload:{
      id:id
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/notifications/actions.js